export default __webpack_public_path__ + "static/media/installer.82ac72b9.png";